
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class MoldMasterGrid extends Serenity.EntityGrid<MoldMasterRow, any> {
        protected getColumnsKey() { return 'OMS.MoldMaster'; }
        protected getDialogType() { return MoldMasterDialog; }
        protected getIdProperty() { return MoldMasterRow.idProperty; }
        protected getInsertPermission() { return MoldMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return MoldMasterRow.localTextPrefix; }
        protected getService() { return MoldMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}